module.exports = __webpack_public_path__ + "static/img/hj.562a5fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/hj.jpg
// module id = YnAL
// module chunks = 1